__turbopack_context__.v({
  "playAllButton": "SectionWithPlayAll-module__Pp6NuG__playAllButton",
  "sectionHeader": "SectionWithPlayAll-module__Pp6NuG__sectionHeader",
  "sliderSection": "SectionWithPlayAll-module__Pp6NuG__sliderSection",
});
